// components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';
import './Logo.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { currentUser, logout } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          {/* Diamond Logo */}
          <div className="cinder-diamond">
            <div className="diamond-inner"></div>
          </div>
          <span className="logo-text">Cinder</span>
        </Link>

        <div className={`navbar-links ${mobileMenuOpen ? 'active' : ''}`}>
          <Link to="/#features" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Features</Link>
          <Link to="/#frameworks" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Frameworks</Link>
          <Link to="/#usage" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Implementation</Link>
          <Link to="/#bit" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Bit</Link>
          <Link to="/#documentation" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Documentation</Link>
          
          {/* Show mobile buttons for small screens */}
          <div className="mobile-buttons">
            {currentUser ? (
              <>
                <Link to="/dashboard" className="mobile-btn btn btn-primary" onClick={() => setMobileMenuOpen(false)}>Dashboard</Link>
                <button onClick={() => { handleLogout(); setMobileMenuOpen(false); }} className="mobile-btn btn btn-secondary">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" className="mobile-btn btn btn-primary" onClick={() => setMobileMenuOpen(false)}>Login</Link>
                <Link to="/signup" className="mobile-btn btn btn-secondary" onClick={() => setMobileMenuOpen(false)}>Sign Up</Link>
              </>
            )}
          </div>
        </div>

        <div className="navbar-buttons">
          {currentUser ? (
            <>
              <Link to="/dashboard" className="btn btn-primary">Dashboard</Link>
              <button onClick={handleLogout} className="btn btn-secondary">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-primary">Login</Link>
              <Link to="/signup" className="btn btn-secondary">Sign Up</Link>
            </>
          )}
        </div>

        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <span className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;